var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.detect == 'pc' ? _c('v-menu', {
    attrs: {
      "top": "",
      "offset-y": "",
      "offset-overflow": "",
      "nudge-top": "10",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('client-chat-view')], 1) : _vm.detect == 'mobile' ? _c('v-bottom-sheet', {
    attrs: {
      "fullscreen": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_vm._t("default", null, null, {
          attrs: attrs,
          on: on
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('client-chat-view'), _c('v-btn', {
    attrs: {
      "fixed": "",
      "top": "",
      "right": "",
      "text": "",
      "fab": ""
    },
    on: {
      "click": function click($event) {
        _vm.shows = false;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }